/** Remonte la fenêtre en tête de page (SPA : le navigateur ne le fait pas toujours). */
export function scrollPageToTop({ behavior } = {}) {
  const smooth =
    behavior ??
    (typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches
      ? "auto"
      : "smooth");
  try {
    window.scrollTo({ top: 0, left: 0, behavior: smooth });
  } catch {
    window.scrollTo(0, 0);
  }
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Plusieurs tentatives après navigation React (layout, hash, restauration). */
export function scrollPageToTopSoon() {
  scrollPageToTop();
  requestAnimationFrame(() => scrollPageToTop());
  window.setTimeout(() => scrollPageToTop({ behavior: "auto" }), 80);
}
